import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { BrandStorySection } from './components/BrandStorySection';
import { FeaturedWinesSection } from './components/FeaturedWinesSection';
import { TerroirSection } from './components/TerroirSection';
import { PhilosophySection } from './components/PhilosophySection';
import { SustainabilitySection } from './components/SustainabilitySection';
import { PressQuoteSection } from './components/PressQuoteSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white w-full overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BrandStorySection data-id="element-4" />
        <FeaturedWinesSection data-id="element-5" />
        <TerroirSection data-id="element-6" />
        <PhilosophySection data-id="element-7" />
        <SustainabilitySection data-id="element-8" />
        <PressQuoteSection data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}